import { render, staticRenderFns } from "./QuotaDetail.vue?vue&type=template&id=ca68ea78&"
import script from "./QuotaDetail.vue?vue&type=script&lang=js&"
export * from "./QuotaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports